export const completedMatches = matches =>
  matches.filter(match => match.statusGame === "Finished");
